import Avatar from "@material-ui/core/Avatar";
import Backdrop from "@material-ui/core/Backdrop";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Fade from "@material-ui/core/Fade";
import Icon from "@material-ui/core/Icon";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import axios from "axios";
import React, { useEffect } from "react";
import AdminDashboard from "./AdminDashboard";
import UserDashboard from "./UserDashboard";
import FormDataInput from "./FormDataInput";
import CancelIcon from "@material-ui/icons/Cancel";

const useStyles = makeStyles((theme) => ({
  button: {
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(10),
    float: "right",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#85b9f0a6",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  avatar1: {
    margin: theme.spacing(1),
    backgroundColor: "#21943b",
  },
  avatar2: {
    margin: theme.spacing(1),
    backgroundColor: "#f50057",
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  registerButton: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
    alignItems: "right",
  },
  userErrorPopup: {
    border: "0.5px solid black",
    borderRadius: "10px",
    margin: "5px",
    padding: "10px",
    display: "none",
  },
}));

export default function LandingPage(props) {
  const classes = useStyles();
  {
    /*.........................................|..................
  ..............user login response and error \|/.................
  .............................................V..................*/
  }
  const [resp, setResp] = React.useState({}); //..........................success response..........................
  const [errorResp, setErrorResp] = React.useState(""); //................error response............................
  {
    /*............................................|...............
  ..............admin login response and error...\|/..............
  ................................................V...............*/
  }
  const [adminResp, setAdminResp] = React.useState({}); //................success respopnse.........................
  const [adminErrorResp, setAdminErrorResp] = React.useState(""); //......error response............................
  {
    /*..............................................|...............
  ..............trigger login modal open/close.....\|/..............
  ..................................................V...............*/
  }
  const [loginOpen, setLoginOpen] = React.useState(false);
  const [mobNumError, triggerMobNumError] = React.useState(false);
  const [mobNumErrorMsg, setMobNumErrorMsg] = React.useState("");
  {
    /*...................................................|...............
  ..............trigger registration form loading.......\|/..............
  .......................................................V...............*/
  }
  const [loadFormDataInput, setloadFormDataInput] = React.useState(true); //................set it to true
  {
    /*...........................................................|...............
  ..............trigger admin dashboard upon successful login...\|/..............
  ...............................................................V...............*/
  }

  const [loadAdminDashboard, setloadAdminDashboard] = React.useState(false);
  {
    /*...........................................................|...............
  ..............trigger user dashboard upon successful login....\|/..............
  ...............................................................V...............*/
  }
  const [loadUserDashboard, setloadUserDashboard] = React.useState(false); //..................set it to false
  const [textLogin, triggerLogin] = React.useState(true);
  {
    /*..............................................|...............
  ..............save user details from form........\|/..............
  ..................................................V...............*/
  }
  const [userDetails, setUserDetails] = React.useState({
    phoneNo: "",
    password: "",
  });
  {
    /*..............................................|...............
  ..............save admin details from form.......\|/..............
  ..................................................V...............*/
  }
  const [adminDetails, setAdminDetails] = React.useState({
    adminId: "",
    password: "",
  });

  const userHandleNumber = (event) => {
    event.preventDefault();
    if (event.target.value.length > 10) {
      triggerMobNumError(true);
      setMobNumErrorMsg("Incorrect Number!");
    } else if (/^[7|8|9]{10}$/i.test(event.target.value)) {
      triggerMobNumError(true);
      setMobNumErrorMsg("Invalid number!!");
    } else if (!/^[789]{1}[0-9]{9}$/i.test(event.target.value)) {
      triggerMobNumError(true);
      setMobNumErrorMsg(
        "maintain the format please! (valid number start with 7,8 or 9)"
      );
    } else {
      triggerMobNumError(false);
      setMobNumErrorMsg("");
      setUserDetails({
        ...userDetails,
        [event.target.name]: event.target.value,
      });
    }
  };
  const userHandlerPassword = (event) => {
    event.preventDefault();
    setUserDetails({ ...userDetails, [event.target.name]: event.target.value });
  };
  const adminHandlerAdminID = (event) => {
    event.preventDefault();
    setAdminDetails({
      ...adminDetails,
      [event.target.name]: event.target.value,
    });
  };
  const adminHandlerPassword = (event) => {
    event.preventDefault();
    setAdminDetails({
      ...adminDetails,
      [event.target.name]: event.target.value,
    });
  };
  {
    /*........................................................................................|...............
  ..............call to backend for user login (will be further implemented in future).......\|/..............
  ............................................................................................V...............*/
  }
  async function userLoginRequest() {
    try {
      let res = await axios.post(
        "http://localhost:8002/eventRegistration/credential/userLogin",
        userDetails
      );
      localStorage.setItem("userId", res.data.phoneNo);
      setResp(res.data);

      let elem = document.getElementById("userLoginErrorPopup");
      elem.style.display = "none";
      setErrorResp("");
      setLoginOpen(false);
      setloadUserDashboard(true);
      setloadAdminDashboard(false);
      setloadFormDataInput(false);
      triggerLogin(false);
    } catch (error) {
      setErrorResp(error.response.data.message);
      if (error.response.data.message === "NO SUCH USER EXIST") {
        triggerMobNumError(true);
        let elem = document.getElementById("userLoginErrorPopup");
        elem.style.display = "inline-block";
      } else {
        let elem = document.getElementById("userLoginErrorPopup");
        elem.style.display = "none";
      }
    }
  }

  useEffect(
    () => {
      setUserDetails(userDetails);
      setAdminDetails(adminDetails);
    },
    [userDetails],
    [adminDetails]
  );

  {
    /*..............................................|...............
  ..............initiate user login................\|/..............
  ..................................................V...............*/
  }
  const userHandlerSubmit = () => {
    userLoginRequest();
  };
  {
    /*........................................................................................|...............
  ..............call to backend for admin login (will be further implemented in future)......\|/..............
  ............................................................................................V...............*/
  }
  async function adminLoginRequest() {
    try {
      let res = await axios.post(
        "http://localhost:8002/eventRegistration/credential/adminLogin",
        adminDetails
      );
      localStorage.setItem("adminId", res.data.adminId);
      setAdminResp(res.data);

      setLoginOpen(false);
      setloadAdminDashboard(true);
      setloadUserDashboard(false);
      setloadFormDataInput(false);
      triggerLogin(false);
      setAdminErrorResp(false);
    } catch (error) {
      setAdminErrorResp(error.response.data.message);
    }
  }
  {
    /*..............................................|...............
  ..............initiate admin login...............\|/..............
  ..................................................V...............*/
  }
  const adminHandlerSubmit = (event) => {
    adminLoginRequest();
  };

  {
    /*..............................................|...............
  ..............initiate login box open............\|/..............
  ..................................................V...............*/
  }
  const handleLoginOpen = () => {
    if (textLogin === true) {
      setLoginOpen(true);
    } else {
      triggerLogin(true);
      setloadAdminDashboard(false);
      setloadUserDashboard(false);
      setloadFormDataInput(true);
      setAdminResp({});
      setAdminErrorResp("");
      setAdminDetails({
        adminId: "",
        password: "",
      });
      setResp({});
      setErrorResp("");
      setUserDetails({
        phoneNo: "",
        password: "",
      });
    }
  };

  {
    /*..............................................|...............
  ..............initiate login box close...........\|/..............
  ..................................................V...............*/
  }
  const handleLoginClose = () => {
    setLoginOpen(false);
  };

  {
    /*....................................................|...............
  ..............toggle between admin and user login......\|/..............
  ........................................................V...............*/
  }
  const toggleAdminForm = () => {
    let userLoginForm = document.getElementById("userForm");
    let adminLoginForm = document.getElementById("adminForm");
    userLoginForm.style.display = "none";
    adminLoginForm.style.display = "block";
  };

  const toggleUserForm = () => {
    let userLoginForm = document.getElementById("userForm");
    let adminLoginForm = document.getElementById("adminForm");
    userLoginForm.style.display = "block";
    adminLoginForm.style.display = "none";
  };

  return (
    <React.Fragment>
      {/*.....................................................|...............
         ..............toggle button for login and logout....\|/..............
         .....................................................V...............*/}
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={handleLoginOpen}
      >
        {textLogin ? "Login" : "Logout"}
      </Button>
      <hr />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={loginOpen}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={loginOpen}>
          {/*.....................................|...............
             ..............user login form.......\|/..............
             .....................................V...............*/}
          <div className={classes.paper}>
            <Button onClick={handleLoginClose}>
              <CancelIcon />
              Click here to close
            </Button>
            <Container
              id="userForm"
              component="main"
              maxWidth="xs"
              className="col-sm-12"
            >
              <div className={classes.paper}>
                <Avatar className={classes.avatar1}>
                  <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                  Sign in as User
                </Typography>
                <form className={classes.form} noValidate>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="userNumber"
                    label="Mobile Number"
                    name="phoneNo"
                    autoComplete="phoneNo"
                    autoFocus
                    error={mobNumError ? true : false}
                    helperText={mobNumErrorMsg}
                    onChange={userHandleNumber}
                  />
                  {errorResp === "NO SUCH USER EXIST" ? (
                    <Typography color="secondary">{errorResp}</Typography>
                  ) : null}
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="userPassword"
                    autoComplete="userPassword"
                    onChange={userHandlerPassword}
                    error={errorResp === "INCORRECT PASSWORD" ? true : false}
                  />
                  {errorResp === "INCORRECT PASSWORD" ? (
                    <Typography color="secondary">{errorResp}</Typography>
                  ) : null}
                  <Button
                    // type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={userHandlerSubmit}
                  >
                    Sign In as user
                  </Button>
                  <Typography
                    variant="h6"
                    gutterBottom
                    onClick={toggleAdminForm}
                    align="left"
                  >
                    Click here to login as <strong>admin</strong>
                  </Typography>{" "}
                  <br />
                  <Typography
                    id="userLoginErrorPopup"
                    className={classes.userErrorPopup}
                  >
                    Click here to create an account{" "}
                    <img
                      style={{ width: "30px" }}
                      src="./images/downArrow.gif"
                    />
                  </Typography>
                  <br />
                  <Icon color="secondary">add_circle</Icon>
                  <Typography
                    variant="h8"
                    gutterBottom
                    align="right"
                    color="secondary"
                  >
                    Not registered? Click here to create an account
                  </Typography>
                </form>
              </div>
            </Container>
            {/*.....................................^...............
             ..............user login form........./|\..............
             .......................................|...............
             .......................................................*/}
            {/*.....................................|...............
             ..............admin login form........\|/..............
             .......................................V...............*/}
            <Container
              id="adminForm"
              style={{ display: "none" }}
              component="main"
              maxWidth="xs"
              className="col-sm-12"
            >
              <div className={classes.paper}>
                <Avatar className={classes.avatar2}>
                  <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                  Sign in as admin
                </Typography>
                <form className={classes.form} noValidate>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="adminId"
                    label="Admin ID"
                    name="adminId"
                    autoComplete="adminId"
                    error={
                      adminErrorResp === "NO SUCH ADMIN EXIST" ? true : false
                    }
                    onChange={adminHandlerAdminID}
                  />
                  {adminErrorResp === "NO SUCH ADMIN EXIST" ? (
                    <Typography color="secondary">{adminErrorResp}</Typography>
                  ) : null}
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="adminPassword"
                    autoComplete="adminPassword"
                    onChange={adminHandlerPassword}
                    error={
                      adminErrorResp === "INCORRECT PASSWORD" ? true : false
                    }
                  />
                  {adminErrorResp === "INCORRECT PASSWORD" ? (
                    <Typography color="secondary">{adminErrorResp}</Typography>
                  ) : null}
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={adminHandlerSubmit}
                  >
                    Sign In as admin
                  </Button>
                  <Typography
                    variant="h6"
                    gutterBottom
                    onClick={toggleUserForm}
                  >
                    Click here to login as <strong>user</strong>
                  </Typography>
                </form>
              </div>
            </Container>
            {/*.....................................^...............
             ..............admin login form......../|\..............
             .......................................|...............*/}
          </div>
        </Fade>
      </Modal>
      {/*................................................|...............
         ......................registration form........\|/..............
         ................................................V...............*/}
      {loadAdminDashboard ? <AdminDashboard adminResp={adminResp} /> : null}
      {loadUserDashboard ? <UserDashboard userResp={resp} /> : null}
      {loadFormDataInput ? <FormDataInput /> : null}
    </React.Fragment>
  );
}
